import * as actions from "../action.constants";
import {ObjectGrouping} from "../../helpers/";

const initialState = {
  isLoading: false,
  controllersList: [],
  etheretConfigurations: ObjectGrouping({}),
  wifiConfigurations: {},
  selectedController: {},
  summary: {},
  systemLogs: {},
  sensorSummary: {},
  analogBanks: [],
  favourite: false,
  favourites: [],
  sensorData: {},
  calibrationCmds: [],
  calibrationHistory: {},
  categoryList: [],
  snapshot: {},
  controllersWithActiveAlert: [],
  controllerSensorData: [],
};

const storeControllers = (state, action) => {
  return {...state, controllersList: action.payload};
};

const wifiEthernetConfigs = (state, action) => {
  return {...state, wifiConfigurations: action.payload};
};

const saveController = (state, action) => {
  return {...state, selectedController: action.info};
};

const saveSystemProperties = (state, action) => {
  return {...state, selectedController: action.payload};
};

const saveSummaryDetails = (state, action) => {
  return {
    ...state,
    summary: action.payload,
  };
};

const storeSensorDraftDetails = (state, action) => {
  return {
    ...state,
    sensorDetailsDraft: action.data,
  };
};

const resetStoredDraftedDetails = (state) => {
  return {
    ...state,
    sensorDetailsDraft: {},
  };
};

const handleStoreSystemLogs = (state, action) => {
  return {
    ...state,
    systemLogs: action.payload,
  };
};

const storeSensorSummary = (state, action) => {
  return {
    ...state,
    sensorSummary: action.payload,
  };
};

const resetSensorSummary = (state) => {
  return {
    ...state,
    sensorSummary: {},
  };
};

const storeAnalogBank = (state, action) => {
  return {
    ...state,
    analogBanks: action.payload,
  };
};

const storeFavourite = (state, action) => {
  return {
    ...state,
    favourite: action.payload,
  };
};

const storeFavourites = (state, action) => {
  return {
    ...state,
    favourites: action.payload,
  };
};

const storeInventorySensorSummary = (state, action) => {
  return {
    ...state,
    sensorData: action.payload,
  };
};

const storeSensorCalibrationCommands = (state, action) => {
  return {
    ...state,
    calibrationCmds: action.payload,
  };
};

const storeSensorCalibrationHistory = (state, action) => {
  return {
    ...state,
    calibrationHistory: action.payload,
  };
};

const storeCategoriesDetails = (state, action) => ({
  ...state,
  categoryList: action.payload || [],
  isLoading: false,
});

const storeControllersWithActiveAlert = (state, action) => ({
  ...state,
  controllersWithActiveAlert: action.payload || [],
});

const storeSnapshot = (state, action) => ({
  ...state,
  snapshot: action.payload || {},
});
const storeControllerSensorData = (state, action) => ({
  ...state,
  controllerSensorData: action.payload || [],
});

const resetControllerSensorData = (state) => ({
  ...state,
  controllerSensorData: initialState.controllerSensorData,
});

const handlers = {
  [actions.STORE_CONTROLLERS]: storeControllers,
  [actions.STORE_WIFI_CONFIG]: wifiEthernetConfigs,
  [actions.SAVE_SELECTED_CONTROLLER]: saveController,
  [actions.STORE_SYSTEM_PROPERTIES]: saveSystemProperties,
  [actions.STORE_SYSTEM_SUMMARY_DATA]: saveSummaryDetails,
  [actions.STORE_SENSOR_CONFIG_DRAFT]: storeSensorDraftDetails,
  [actions.RESET_DRAFT_SENSOR_DATA]: resetStoredDraftedDetails,
  [actions.STORE_SYSTEM_LOGS]: handleStoreSystemLogs,
  [actions.STORE_SENSOR_SUMMARY_DATA]: storeSensorSummary,
  [actions.REQUEST_SENSOR_SUMMARY_RESET_DATA]: resetSensorSummary,
  [actions.STORE_ANALOG_BANK]: storeAnalogBank,
  [actions.STORE_SYSTEM_FAVOURITE]: storeFavourite,
  [actions.STORE_SYSTEM_FAVOURITES]: storeFavourites,
  [actions.STORE_INVENTORY_SENSOR]: storeInventorySensorSummary,
  [actions.STORE_INVENTORY_SENSOR_CALIBRATE_CMDS]: storeSensorCalibrationCommands,
  [actions.STORE_INVENTORY_SENSOR_CALIBRATION_HISTORY]: storeSensorCalibrationHistory,
  [actions.STORE_CATEGORIES]: storeCategoriesDetails,
  [actions.SAVE_CONTROLLERS_WITH_ACTIVE_ALERT]: storeControllersWithActiveAlert,
  [actions.STORE_SNAPSHOT]: storeSnapshot,
  [actions.STORE_CONTROLLER_SENSOR_DATA]: storeControllerSensorData,
  [actions.RESET_CONTROLLER_SENSOR_DATA]: resetControllerSensorData,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
